import { Component, EventEmitter, Output, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "loren-dashboard-create-asset-state",
    templateUrl: "./loren-dashboard-create-asset-state.component.html",
    styleUrls: ["./loren-dashboard-create-asset-state.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenDashboardCreateAssetStateComponent {
  @Output() defineAssetClick = new EventEmitter<Event>();
}
